<template>
  <v-card class="text-center infoBannerContent" flat>
     <div >
     
       <!-- <v-img :src="require('@/assets/image/subscriber.png')" style="width:90px;margin: auto; margin-top: -8pt" ></v-img> -->
       <v-img :src="require('@/assets/image/subscriber.png')" style= "width:3.91em; margin: auto; margin-top:-25.4974px;" ></v-img>
      
       <v-card-text>
        <h5 class="content">Subscribers</h5>
        <h5 class="content count">{{ totalSubscribers }}</h5>
   </v-card-text>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "subscripers",
  props: ["totalSubscribers"],
};
</script>
<style scoped>
.infoBannerContent {
  background-color: transparent;
}
.content {
  /* font-size: 1.58em;
  font-weight: 300;
  color: white; */
  margin: auto;
  font-size: 25px;
  line-height : 22.65px;
  font-weight: 300;
  color : #FFFFFF;;
}
.count{
  /* padding-top: 15pt; */
  /* font-size: 2.42em;
  font-weight: 200; */
   padding-top: 12.6769px;
  font-size : 29px;
  line-height : 22.65px;
  font-weight: 200;

}
</style>>
 